import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import "./thank.css";

export function ThankYouPage({ fetchOrder, order, isLoading }) {
  const navigate = useNavigate();
  const { id } = useParams();
  useEffect(() => {
    if(id) {
      fetchOrder(id);
    }
  }, [id]);

  const cart = JSON.parse(order?.cart || "[]");
  return (
    <>
    <div className="container invoice-box my-4">
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3 py-3 border-bottom mb-3 text-center text-md-start">
          <p className="mb-0" style={{ cursor: "pointer" }} onClick={() => navigate("/")}>
            <i className="fa fa-arrow-left"></i> Go Back
          </p>
          <h4 className="mb-0 text-success">Thank you for your order. You will get an email with the invoice.</h4>
          <span className="d-none d-md-inline">&nbsp;</span>
      </div>
        <div className="invoice-header" style={{ paddingTop: "15px" }}>
            <h2>Bhabhuti Herbal Products</h2>
            <p>Address: 1/1 Housing Board Colony, Hanumangarh Junction - 335512</p>
            <p>GSTIN: 08DFKPS2585l1ZL</p>
        </div>
        <hr className="borders" />
        <div className="inv-head">
            <h6> TAX INVOICE/BILL OF SUPPLY</h6>
        </div>
        <div className="invoice-container mb-4">
            <div className="invoice-headerr">
                <div>
                    Payment No. : <span className="bold-text">{order?.transactionId}</span> <br />
                    Order No : <span className="bold-text">{order?.id}</span>
                </div>
                <div>
                    Place Of Supply : <span className="bold-text">{order?.shippingState}</span> <br />
                    Date : <span className="bold-text">{new Date().toDateString()}</span>
                </div>
            </div>

            <div className="table-responsive">
                <table className="table mb-0">
                    <thead>
                        <tr>
                            <th>Bill To</th>
                            <th>Ship To</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><span className="bold-text">{order?.billingName}</span> <br />
                                {order.billingAddress}&nbsp;{order.billingCity}&nbsp;{order.billingState}&nbsp;{order.billingCountry}-{order.billingZip}
                            </td>
                            <td>
                              {order.shippingAddress}&nbsp;{order.shippingCity}&nbsp;{order.shippingState}&nbsp;{order.shippingCountry}-{order.shippingZip}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div className="table-responsive mb-4">
            <table className="table table-bordered mb-0">
                <thead>
                    <tr className="tr-borders">
                        <th style={{ minWidth: "60px" }}>SR No</th>
                        <th style={{ minWidth: "150px" }}>Item & Description</th>
                        <th style={{ minWidth: "80px" }}>HSN</th>
                        <th style={{ minWidth: "60px" }}>Qty</th>
                        <th style={{ minWidth: "110px" }}>Product Rate</th>
                        <th style={{ minWidth: "80px" }}>Disc.</th>
                        <th style={{ minWidth: "110px" }}>Taxable Amt.</th>
                        <th style={{ minWidth: "70px" }}>CGST</th>
                        <th style={{ minWidth: "90px" }}>CGST Amt.</th>
                        <th style={{ minWidth: "70px" }}>S/UT GST</th>
                        <th style={{ minWidth: "90px" }}>S/UT GST Amt.</th>
                        <th style={{ minWidth: "60px" }}>Cess</th>
                        <th style={{ minWidth: "80px" }}>Cess Amt.</th>
                        <th style={{ minWidth: "100px" }}>Total Amt.</th>
                    </tr>
                </thead>
                <tbody>
                  {Array.isArray(cart) && cart?.map((x, i) => {
                    const productPrice = x?.Product?.currentPrice * x?.quantity;
                    const gstRate = parseInt(x?.Product?.gst || 0);
                    const productRealPrice = parseFloat(x?.Product?.currentPrice || 0);
                    const productDiscount = productPrice * ((order?.discountPercent || 0) / 100);
                    const productRealSellingPrice = productPrice - productDiscount;
                    const priceWithoutGst = productRealSellingPrice;
                    const rowGstTotal = priceWithoutGst * (gstRate / 100);
                    const rowTotal = priceWithoutGst + rowGstTotal;
                    return (
                    <tr className="tr-borders" key={i}>
                        <td>{i + 1}</td>
                        <td>{x?.Product?.name}</td>
                        <td>{x?.Product?.hsn}</td>
                        <td>{x?.quantity}</td>
                        <td>{productRealPrice.toFixed(2)}</td>
                        <td>{productDiscount.toFixed(2)}</td>
                        <td>{priceWithoutGst.toFixed(2)}</td>
                        <td>{gstRate / 2}%</td>
                        <td>{(priceWithoutGst * (gstRate / 200)).toFixed(2)}</td>
                        <td>{gstRate / 2}%</td>
                        <td>{(priceWithoutGst * (gstRate / 200)).toFixed(2)}</td>
                        <td>0.0</td>
                        <td>0.0</td>
                        <td>{rowTotal.toFixed(2)}</td>
                    </tr>
                  )})}
                    <tr className="tr-borders">
                        <td></td>
                        <td> </td>
                        <td> </td>
                        <td>{order.quantity}</td>
                        <td> </td>
                        <td>{order.discount}</td>
                        <td> </td>
                        <td> </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>0.0</td>
                        <td>{(order?.total - order.discount + order.gstAmount).toFixed(2)}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div className="row justify-content-end mb-4">
            <div className="col-7 col-md-5 text-end">
                <p className="mb-2"><strong>Item Total:</strong></p>
                <p className="mb-2"><strong>GST Charges:</strong></p>
                <p className="mb-2"><strong>Shipping Fee (Inclusive of Taxes):</strong></p>
                <p className="mb-0 text-success" style={{ fontSize: "16px" }}><strong>Invoice Value:</strong></p>
            </div>
            <div className="col-5 col-md-3 text-end">
                <p className="mb-2"><strong>₹{(order?.total - order.discount).toFixed(2)}</strong></p>
                <p className="mb-2"><strong>₹{order?.gstAmount?.toFixed(2)}</strong></p>
                <p className="mb-2"><strong>₹{order?.shippingAmount?.toFixed(2)}</strong></p>
                <p className="mb-0 text-success" style={{ fontSize: "16px" }}><strong>₹{order.finalAmount?.toFixed(2)}</strong></p>
            </div>
        </div>

        <hr className="borders" />

        <div className="row mt-4 pt-3 border-top">
            <div className="col-12 col-md-7 mb-4 mb-md-0" style={{ fontSize: "12px", color: "#666", lineHeight: "1.5" }}>
                Whether GST is payable on reverse charge - No.<br /><br />
                Charges/Fees mentioned above (For instance, Delivery Charges, Surge Fees, Packaging Charges, etc.)
                are apportioned to each product included in this invoice in the ratio of taxable value for
                computation of applicable Goods and Services Tax and/or Compensation Cess, and accordingly, Goods
                and Services Tax and/or Compensation Cess are computed, disclosed (please refer to the annexure) and
                collected in the invoice
            </div>
            <div className="col-12 col-md-5 text-center d-flex flex-column align-items-center justify-content-center">
                <div className="signature border p-3 rounded bg-light" style={{ width: "100%", maxWidth: "250px" }}>
                    <p className="mb-1" style={{ fontSize: "12px", color: "#666" }}>Digitally Signed by:</p>
                    <h6 className="mb-0 fw-bold text-dark">Bhabhuti Herbal Products</h6>
                </div>
            </div>
        </div>

    </div>
    </>
  );
}